import Head from "next/head";
import clarity from "./clarity";
import { useEffect, useState } from "react";

import { useRouter } from "next/router";
import { curren } from "markdown-it/lib/common/entities";
const Meta = ({ title, keyword, desc, src, canonicalUrl, noIndex=false }) => {

  const [favicon, setFavicon] = useState("/SynthiaHire.png");
  const [whiteLabel, setWhitelabel] = useState("");

  const router = useRouter();
  useEffect(() => {
    const url = window.location.href;
      setFavicon("/SynthiaHire.png");
      setWhitelabel("SynthiaHire | ");

  }, [])
  var ogTitle = "#1 platform for AI interviews powered by GenAI";
  if (!canonicalUrl) {
    const currentPath = router.asPath;
    // console.log("title in meta", currentPath);
    const newUrl = `${process.env.FRONTENDURL}${currentPath}`;

    canonicalUrl = newUrl;
    // console.log("meta in meta", newUrl);
  }

  title = whiteLabel + title;
  useEffect(() => {
    clarity(window, document, "clarity", "script", "ecjaqpithh");
  }, []);

  return (
    <div>
      <Head>
        <title>{title}</title>
        <link rel="icon" href={favicon} />
        <meta name="description" content={desc} />
        <meta name="keyword" content={keyword} />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={ogTitle} />
        {noIndex && <meta name="robots" content="noindex, nofollow" />}
        <meta
          property="og:description"
          content="Replace traditional interviews with AI interviews & cut down your talent assessment cost & time by up to 90% with Generative AI."
        />
        <meta property="og:image" content={src} />
      </Head>
    </div>
  );
};

Meta.defaultProps = {
  title: "#1 platform for AI interviews",
  keyword:
    "SynthiaHire, hiring, recruitment, hire, recruiter, market, AI Interview, Intervies, coding test, online test,AI interviews, talent assessment, skill assessment, AI co-pilot for talent assessment, Video interviews taken by an AI bot, Generative AI for talent assessment, Assess talent with AI interviews",
  desc: "SynthiaHire replaces traditional interviews with AI interviews. Our AI conducts highly contextualized interviews & evaluates the talent to find diamonds in the rough.",
  src: "https://storage.googleapis.com/credohirestorages-3/strapi-credo/assets/og_image_b2bcafbb48.png",
  canonicalUrl: "",
  Whitelabel: "SynthiaHire | "
};

export default Meta;
